var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 4.66797C14.7633 4.66797 15.1294 4.99715 15.1873 5.42424L15.1953 5.54297L15.1953 23.043C15.1953 23.5262 14.8036 23.918 14.3203 23.918C13.8773 23.918 13.5112 23.5888 13.4533 23.1617L13.4453 23.043L13.4453 5.54297C13.4453 5.05972 13.8371 4.66797 14.3203 4.66797Z",
    fill: "#D9DEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7301 15.367C21.0711 15.0245 21.6251 15.0234 21.9675 15.3643C22.2788 15.6743 22.3081 16.1603 22.0547 16.5034L21.9702 16.6018L14.9422 23.6601C14.6313 23.9723 14.1435 24.0007 13.8004 23.7453L13.7021 23.6601L6.67297 16.6018C6.33197 16.2594 6.33312 15.7054 6.67553 15.3644C6.98682 15.0544 7.47298 15.0271 7.815 15.282L7.91297 15.3669L14.3225 21.8023L20.7301 15.367Z",
    fill: "#D9DEF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.13dfcb26.svg";
export { ForwardRef as ReactComponent };